/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.75 24c2.3491 0 4.4459-1.7279 5.8211-4.4327l3.4604 2.7684a.75.75 0 0 0 .937-1.1714l-3.75-3a.9335.9335 0 0 0-.0252-.0193C18.8644 16.3476 19.25 14.2459 19.25 12H23a.75.75 0 0 0 0-1.5h-3.75a.7394.7394 0 0 0-.0579.0022c-.1607-2.0654-.6494-3.9678-1.3802-5.5696l2.5235-1.2618a.75.75 0 0 0 .3354-1.0062.75.75 0 0 0-1.0062-.3354L17.11 3.6065C15.7486 1.381 13.8501 0 11.75 0c-2.1 0-3.9986 1.381-5.36 3.6065L3.8354 2.3292a.75.75 0 0 0-.6708 1.3416L5.688 4.9326c-.7305 1.6012-1.2192 3.5029-1.38 5.5674H1.25a.75.75 0 0 0 0 1.5h3c0 2.2459.3856 4.3476 1.0567 6.145a.9487.9487 0 0 0-.0252.0193l-3.75 3a.75.75 0 0 0 .937 1.1714l3.4604-2.7684C7.3041 22.2721 9.401 24 11.75 24Zm4.0313-4.3097C16.9674 17.7926 17.75 15.0776 17.75 12c0-1.048-.0908-2.054-.2573-3H6.0073c-.1665.946-.2573 1.952-.2573 3 0 3.0776.7826 5.7926 1.9687 7.6903C8.918 21.6091 10.3827 22.5 11.75 22.5c1.3673 0 2.832-.8909 4.0313-2.8097Zm0-15.3806c.5606.8969 1.031 1.9763 1.3713 3.1903H6.3474c.3403-1.214.8107-2.2934 1.3713-3.1903C8.918 2.391 10.3827 1.5 11.75 1.5c1.3673 0 2.832.8909 4.0313 2.8097Z"
    clipRule="evenodd"
  />,
  'Bug'
);
